import { createSelector } from 'reselect';
import type { RootStore } from '../../types/global-store';

export const selectTeam = (state: RootStore) => state.team;
export const selectTeamsCache = (state: RootStore) => state.teams.cache;

export const selectTeams = createSelector(
  selectTeam,
  selectTeamsCache,
  (active, cache) => ({ active, cache })
);
